/* Scratch is presentation only. Shopify's discount engine determines the checkout price. */
if (!customElements.get('catkin-gift-scratch')) {
  customElements.define('catkin-gift-scratch', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.canvas = this.querySelector('canvas');
      this.ctx = this.canvas.getContext('2d', { willReadFrequently: true });
      this.button = this.querySelector('button');
      this.status = this.querySelector('[aria-live]');
      this.button.addEventListener('click', () => this.reveal());
      if (!this.ctx) { this.canvas.hidden = true; this.reveal(); return; }
      this.observer = new ResizeObserver(() => this.paint());
      this.observer.observe(this.canvas.parentElement);
      this.canvas.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.dragging = true; this.last = null;
        this.canvas.setPointerCapture(event.pointerId); this.scratch(event);
      });
      this.canvas.addEventListener('pointermove', event => { if (this.dragging) this.scratch(event); });
      const stop = () => { this.dragging = false; this.last = null; };
      this.canvas.addEventListener('pointerup', stop);
      this.canvas.addEventListener('pointercancel', stop);
      this.timer = setInterval(() => {
        if (this.dataset.demo !== 'true' && Date.now() >= Date.parse(this.dataset.expires)) this.hidden = true;
      }, 30000);
    }
    disconnectedCallback() { this.observer?.disconnect(); clearInterval(this.timer); this.initialized = false; }
    paint() {
      if (this.classList.contains('is-revealed')) return;
      const rect = this.canvas.parentElement.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      this.canvas.width = Math.round(rect.width); this.canvas.height = Math.round(rect.height);
      const ctx = this.ctx, w = this.canvas.width, h = this.canvas.height;
      ctx.globalCompositeOperation = 'source-over';
      const gold = ctx.createLinearGradient(0, 0, w, h);
      gold.addColorStop(0, '#ba873b'); gold.addColorStop(.35, '#f5dfaa'); gold.addColorStop(.6, '#c39a56'); gold.addColorStop(1, '#f2dc9f');
      ctx.fillStyle = gold; ctx.fillRect(0, 0, w, h);
      ctx.strokeStyle = '#fff5d890'; ctx.lineWidth = 1;
      for (let i = -h; i < w; i += 18) { ctx.beginPath(); ctx.moveTo(i, 0); ctx.lineTo(i + h, h); ctx.stroke(); }
      ctx.textAlign = 'center'; ctx.fillStyle = '#4b253a'; ctx.font = '24px Georgia'; ctx.fillText('A surprise awaits', w / 2, h / 2 - 5);
      ctx.font = '12px sans-serif'; ctx.fillText('SCRATCH TO REVEAL', w / 2, h / 2 + 24);
    }
    scratch(event) {
      const rect = this.canvas.getBoundingClientRect();
      const point = { x: (event.clientX - rect.left) * this.canvas.width / rect.width, y: (event.clientY - rect.top) * this.canvas.height / rect.height };
      const ctx = this.ctx; ctx.globalCompositeOperation = 'destination-out'; ctx.lineWidth = 36; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(this.last?.x ?? point.x, this.last?.y ?? point.y); ctx.lineTo(point.x, point.y); ctx.stroke();
      ctx.beginPath(); ctx.arc(point.x, point.y, 18, 0, Math.PI * 2); ctx.fill(); this.last = point;
      if (!this.nextCheck || performance.now() > this.nextCheck) {
        this.nextCheck = performance.now() + 150;
        const pixels = ctx.getImageData(0, 0, this.canvas.width, this.canvas.height).data;
        let cleared = 0, sampled = 0;
        for (let i = 3; i < pixels.length; i += 64) { sampled++; if (pixels[i] < 40) cleared++; }
        if (cleared / sampled > .4) this.reveal();
      }
    }
    reveal() {
      if (this.classList.contains('is-revealed')) return;
      this.classList.add('is-revealed');
      this.querySelector('.diwali-gift__reward').removeAttribute('aria-hidden');
      this.status.textContent = this.dataset.demo === 'true' ? 'Preview revealed. Checkout offer is not active.' : 'Your gift offer is revealed and will apply automatically at checkout.';
      this.button.textContent = 'Gift revealed'; this.button.disabled = true;
    }
  });
}
